<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_244')"
    icon="res-billaccount"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :res-id="detailData.id"
      :id="listId"
      :data="detailData"
      :accountData="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :defaultAccountId="detailData.id"
      :showBillShared="true"
      :getParams="getParams"
      :columns="columns"
      @tab-change="handleTabChange"
      @updateAccount="fetchAccount" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import BillTask from '@Cloudenv/views/billtasks/components/List.vue'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import Detail from './Detail'
import RiOverview from './RiOverview'
import CppSharing from './CppSharing'
import ProjectSharing from './Sharing'
import AccountPeriod from './AccountPeriod'

export default {
  name: 'BillAccountSidePage',
  components: {
    Actions,
    Overview,
    RiOverview,
    CppSharing,
    Detail,
    ProjectSharing,
    BillTask,
    AccountPeriod,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      isSidepage: true,
    }
  },
  computed: {
    detailTabs () {
      const tabs = [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ]
      if (this.detailData) {
        const { brand, access_url } = this.detailData
        if (brand === 'Azure' && access_url === 'AzureChinaCloud') {
          tabs.push({ label: this.$t('bill.cpp_shared'), key: 'cpp-sharing' })
          // tabs.push({ label: this.$t('bill.cpp_shared'), key: 'cpp-shared' })
        }
        if (brand === 'Aws' || (brand === 'Azure' && access_url === 'AzurePublicCloud')) {
          tabs.push({ label: this.$t('bill.ri_analysis'), key: 'ri-overview' })
        }
      }
      if (this.detailData) {
        tabs.push({ label: this.$t('bill.sharing'), key: 'project-sharing' })
      }
      tabs.push({ label: this.$t('bill.bill_tasks'), key: 'bill-task' })
      tabs.push({ label: this.$t('bill.accounting_period'), key: 'account-period' })
      if (this.detailData.id !== 'yunion') {
        tabs.splice(0, 0, { label: this.$t('cloudenv.text_237'), key: 'detail' })
        tabs.push({ label: this.$t('cloudenv.text_15'), key: 'event-drawer' })
      }
      return tabs
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillAccountSidePage'
        case 'ri-overview':
          return 'RiOverviewForBillAccountSidePage'
        case 'project-sharing':
          return 'ProjectSharingForBillAccountSidePage'
        case 'bill-task':
          return 'BillTaskForCloudaccountSidepage'
        case 'sharing-record':
          return 'SharingRecordForCloudaccountSidepage'
        case 'event-drawer':
          return 'EventListForCloudaccountSidePage'
        case 'account-period':
          return 'AccountPeriodForBillAccountSidePage'
        default:
          return ''
      }
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || 'month'
      return { dateParam, dateMode }
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'account', 'platform', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'account', 'platform', 'external_project']
      }
      return ['account', 'platform', 'external_project']
    },
    getParams () {
      if (this.params.windowData.currentTab === 'bill-task') {
        return {
          account_id: this.detailData.id,
        }
      }
      return {}
    },
  },
  created () {
    this.initChangeTab2()
  },
  methods: {
    initChangeTab () {
      const { tab } = this.params
      const { currentTab } = this.params.windowData
      if (!currentTab) {
        this.handleTabChange(tab)
      }
    },
    initChangeTab2 () {
      const { tab } = this.params
      const { currentTab } = this.params.windowData
      if (!this.detailTabs.some(item => item.key === currentTab)) {
        this.handleTabChange(tab)
      }
    },
  },
}
</script>
